(() => {
  if (window.mmProductForms) return;
  const initialize = (root = document) => {
    root.querySelectorAll('[data-mm-product-form]').forEach((form) => {
      if (form.dataset.mmInitialized) return;
      form.dataset.mmInitialized = 'true';
      const idInput = form.querySelector('[name="id"]');
      const submit = form.querySelector('[type="submit"]');
      const action = submit.querySelector('[data-mm-buy-label]');
      const price = submit.querySelector('[data-mm-buy-price]');
      const note = form.querySelector('[data-mm-form-note]');
      const card = form.closest('[data-mm-buy]');
      const demand = card.querySelector('[data-mm-demand]');
      const buttons = [...form.querySelectorAll('[data-mm-variant], [data-mm-demand-size]')];
      let variants = [];
      try { variants = JSON.parse(form.querySelector('[data-mm-variants]').textContent); } catch (_) {}
      const state = { variant: null, demand: null, trigger: null, pending: false };
      const variantFor = (id) => variants.find((variant) => String(variant.id) === String(id) && variant.available);
      const valid = () => state.variant && variantFor(state.variant.id) && String(state.variant.id) === idInput.value;
      const announce = (message, error = false) => {
        note.textContent = message;
        note.dataset.error = String(error);
        if (error) note.focus();
      };
      const sync = () => {
        idInput.value = state.variant ? String(state.variant.id) : '';
        submit.disabled = state.pending || !valid();
        form.setAttribute('aria-busy', String(state.pending));
        buttons.forEach((button) => {
          const selected = state.variant ? button.dataset.mmVariant === String(state.variant.id) : button.dataset.mmDemandSize === state.demand;
          button.setAttribute('aria-checked', String(Boolean(selected)));
          button.tabIndex = selected || (!state.variant && !state.demand && button === buttons[0]) ? 0 : -1;
          button.disabled = state.pending;
          if (button.dataset.mmDemandSize) button.setAttribute('aria-expanded', String(selected && !demand.hidden));
        });
      };
      const closeDemand = () => {
        demand.hidden = true;
        sync();
        state.trigger?.focus();
      };
      const choose = (button, focusEmail = true) => {
        if (state.pending) return;
        state.variant = button.dataset.mmVariant ? variantFor(button.dataset.mmVariant) || null : null;
        state.demand = state.variant ? null : button.dataset.mmDemandSize || null;
        state.trigger = button;
        demand.hidden = !state.demand;
        if (state.demand) {
          card.querySelector('[data-mm-demand-label]').textContent = state.demand;
          card.querySelector('[data-mm-demand-tags]').value = 'newsletter,groesseninteresse-longsleeve-' + state.demand.toLowerCase();
          announce('Größe ' + state.demand + ' ist nicht kaufbar. Unverbindlich vormerken ist kein Kauf.');
        } else if (state.variant) {
          if (button.dataset.price) price.textContent = button.dataset.price;
          announce('Größe ' + state.variant.title + ' ausgewählt. Körpernaher Schnitt.');
        } else announce('Bitte wähle eine verfügbare Größe.', true);
        sync();
        if (state.demand && focusEmail) card.querySelector('[type="email"]')?.focus({ preventScroll: true });
      };
      buttons.forEach((button, index) => {
        button.addEventListener('click', () => choose(button));
        button.addEventListener('keydown', (event) => {
          let next;
          if (event.key === 'ArrowRight' || event.key === 'ArrowDown') next = (index + 1) % buttons.length;
          if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') next = (index - 1 + buttons.length) % buttons.length;
          if (event.key === 'Home') next = 0;
          if (event.key === 'End') next = buttons.length - 1;
          if (next === undefined) return;
          event.preventDefault();
          choose(buttons[next], false);
          buttons[next].focus();
        });
      });
      card.querySelector('[data-mm-demand-close]').addEventListener('click', closeDemand);
      demand.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') { event.preventDefault(); closeDemand(); }
      });
      state.variant = variantFor(idInput.value) || null;
      sync();
      if (card.querySelector('[data-mm-demand-success], .errors')) demand.hidden = false;
      form.addEventListener('submit', async (event) => {
        event.preventDefault();
        if (state.pending) return;
        if (!valid()) {
          state.variant = null;
          sync();
          announce('Bitte wähle eine verfügbare Größe. Vormerkgrößen können nicht gekauft werden.', true);
          return;
        }
        const body = new FormData(form);
        body.set('id', String(state.variant.id));
        state.pending = true;
        sync();
        action.textContent = 'Wird hinzugefügt …';
        try {
          const response = await fetch(window.Shopify.routes.root + 'cart/add.js', {
            method: 'POST', headers: { Accept: 'application/json' }, body
          });
          if (!response.ok) throw new Error('add_failed');
          window.location.assign(window.Shopify.routes.root + 'cart');
        } catch (_) {
          state.pending = false;
          action.textContent = 'In den Warenkorb';
          sync();
          announce('Das Hinzufügen hat nicht geklappt. Prüfe deine Größe und versuche es erneut.', true);
        }
      });
    });
  };
  window.mmProductForms = { initialize };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialize());
  else initialize();
  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
})();
